import { TicketApiService } from 'Services/ApiServices';
import { setLoader } from 'Store/Actions/Loading/LoadingAction';
import F2WCustomLogger from 'Services/F2WCustomLogger';

/**
 * Factory function that creates a server-side datasource for AgGrid.
 * @param {string} endpoint - The API endpoint (e.g. 'staff/agGridTable/PendingBTT')
 * @param {string} viewName - Name used for logging (e.g. 'StatusPendingBtt')
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} gridRef - React ref to the AgGridReact component
 * @returns {Object} Server-side datasource object with getRows method
 */
export const createServerSideDatasource = (endpoint, viewName, dispatch, gridRef) => {
  return {
    getRows: async (params) => {
      try {
        const response = await TicketApiService.getAgGridData(endpoint, params.request);
        const data = response?.data || response;
        if (data?.rows) {
          if (data.totalRows === 0) {
            gridRef.current.api.showNoRowsOverlay();
          }
          params.success({ rowData: data.rows, rowCount: data.rowCount });
        } else {
          params.fail();
        }
      } catch (error) {
        F2WCustomLogger.error('Error fetching grid data', error, {
          view: viewName,
          startRow: params.request.startRow,
          endRow: params.request.endRow,
        });
        params.fail();
      } finally {
        dispatch(setLoader(false));
      }
    },
  };
};
